import { useSyncExternalStore } from 'react';
import {
  getCoordinatorVisibleState,
  subscribeCoordinator,
} from '@/lib/loading/loadingCoordinatorStore';
import type { CoordinatorVisibleState } from '@/lib/loading/types';

export function useLoadingCoordinator(): CoordinatorVisibleState {
  return useSyncExternalStore(subscribeCoordinator, getCoordinatorVisibleState, getCoordinatorVisibleState);
}
